import { AXLE_TEAL, LIGHT_AXLE_TEAL_BACKGROUND } from '@/constants/colors';
import { alpha, lighten } from '@mui/material';

const HIGHLIGHTED_COLUMN_STYLES = {
    backgroundColor: LIGHT_AXLE_TEAL_BACKGROUND,
    borderTop: `1px solid ${lighten(AXLE_TEAL, 0.5)}`,
    borderLeft: `1px solid ${AXLE_TEAL}`,
    borderRight: `1px solid ${AXLE_TEAL}`,
    borderBottom: `1px solid ${lighten(AXLE_TEAL, 0.5)}`,
};

const DESELECTED_COLUMN_STYLES = {
    backgroundColor: alpha(lighten(LIGHT_AXLE_TEAL_BACKGROUND, 0.1), 0.5),
    borderTop: `1px solid ${alpha(lighten(AXLE_TEAL, 0.5), 0.5)}`,
    borderLeft: `1px solid ${alpha(AXLE_TEAL, 0.5)}`,
    borderRight: `1px solid ${alpha(AXLE_TEAL, 0.5)}`,
    borderBottom: `1px solid ${alpha(lighten(AXLE_TEAL, 0.5), 0.5)}`,
};

export const getCellHighlightProps = (highlighted: boolean | null) => {
    if (highlighted === null) {
        return {};
    }
    return highlighted ? { ...HIGHLIGHTED_COLUMN_STYLES } : { ...DESELECTED_COLUMN_STYLES };
};

export const getSetCellProps = (isHighlighted: boolean | null) => ({
    sx: {
        width: '280px',
        ...getCellHighlightProps(isHighlighted),
    },
});
